import React from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Header, Wrapper } from '../../components_renew/Layout'
import imgBg1 from '../../assets/xiniu/integral_event_3/bg_01.jpg'
import imgBg2 from '../../assets/xiniu/integral_event_3/bg_02.jpg'
import imgBg3 from '../../assets/xiniu/integral_event_3/bg_03.jpg'
import imgBg4 from '../../assets/xiniu/integral_event_3/bg_04.jpg'
// import xibei_imgBg1 from '../../assets/xibei/integral_event_2/bg_01.jpg'
// import xibei_imgBg2 from '../../assets/xibei/integral_event_2/bg_02.jpg'
// import xibei_imgBg3 from '../../assets/xibei/integral_event_2/bg_03.jpg'
// import xibei_imgBg4 from '../../assets/xibei/integral_event_2/bg_04.jpg'
import imgCard1 from '../../assets/xiniu/integral_event_3/card_01.png'
import imgCard2 from '../../assets/xiniu/integral_event_3/card_02.png'
import imgCard3 from '../../assets/xiniu/integral_event_3/card_03.png'
import imgCard4 from '../../assets/xiniu/integral_event_3/card_04.png'
import api from '../../api'
import { handleCatch, postMessage } from '../../utils'

const assets = {
  bg1: '',
  bg2: '',
  bg3: '',
  bg4: '',
  card1: imgCard1,
  card2: imgCard2,
  card3: imgCard3,
  card4: imgCard4,
}

switch (process.env['REACT_APP_CHANNEL']) {
  // case 'xibei':
  //   assets.bg1 = xibei_imgBg1
  //   assets.bg2 = xibei_imgBg2
  //   assets.bg3 = xibei_imgBg3
  //   assets.bg4 = xibei_imgBg4
  //   break
  default:
    // xiniu
    assets.bg1 = imgBg1
    assets.bg2 = imgBg2
    assets.bg3 = imgBg3
    assets.bg4 = imgBg4
}

@withRouter
class IntegralEvent3 extends React.PureComponent {
  state = {
    // 可兑换代金券
    amount: 0,
    // 今日累计订单金额
    cumulativeMoney: 0,
    // 将领取积分
    predictGiveIntegral: 0,
    // 已领取积分
    integral: 0,
    success: false,
  }

  componentDidMount () {
    document.title = '非农掘金'
    window.toast.loading()
    api.integral.fetchUserCumulativeMoneyToday()
      .then(res => {
        if (res) {
          this.setState({})
          api.integral.fetchUserIntegralToday().then(integral => {
            window.toast.hide()
            this.setState({ success: true })
            if (integral > 0) {
              this.setState({
                integral,
                cumulativeMoney: res['cumulativeMoney'],
                predictGiveIntegral: res['predictGiveIntegral'],
                amount: Number(((res['predictGiveIntegral'] + integral) / 10).toFixed(1))
              })
            }
          })
            .catch(handleCatch)
        }
      })
      .catch(handleCatch)

  }

  render () {
    const { withHeader } = this.props
    const { amount, cumulativeMoney, integral, predictGiveIntegral } = this.state
    return <Container>
      {withHeader ? <Header>非农掘金</Header> : null}
      <Wrapper>
        <img className='events-bg' src={assets.bg1} alt=''/>
        <div className={'events-card'} style={{ padding: '0 2rem' }}>
          <div className={'events-card__content'} style={{ width: 320 }}>
            <img className={'events-card__item'} src={assets.card1} alt=''/>
            <div className={'events-card__text events-card--primary'}
                 style={{ fontSize: 12, color: '#ea3105' }}>已领取 {integral} 积分，将领取 {predictGiveIntegral} 积分
            </div>
            <img className={'events-card__item'} src={assets.card2} alt=''/>
            <div className={'events-card__text events-card--primary'}
                 style={{ fontWeight: 'bold', fontSize: 18, color: '#fff2a4' }}>可兑换 {amount} 元代金券
            </div>
            <img className={'events-card__item'} src={assets.card3} alt=''/>
            <div className={'events-card__text'}
                 style={{ color: '#ea3105', fontSize: 12 }}>
              今日订单总金额：{cumulativeMoney} 元
            </div>
            <img className={'events-card__item'} src={assets.card4} alt=''/>
          </div>
        </div>
        <img className='events-bg' src={assets.bg2} alt=''/>
        <img className='events-bg' src={assets.bg3} alt='' onClick={this.goToBuy}/>
        <img className='events-bg' src={assets.bg4} alt=''/>
      </Wrapper>
    </Container>
  }

  onBtnClick = () => {
    postMessage({
      type: window.POST_TYPE.INTEGRAL
      // type: 'integral'
    })
  }

  goToBuy = () => {
    postMessage({
      type: window.POST_TYPE.BUY
    })
  }
}

export default IntegralEvent3
